module.exports = __webpack_public_path__ + "media/images/athletes/1382-83ae517fd2887fcd8640cc3eb8997a89.png";